import AbstractList from '../list/AbstractList';

export default class AbstractGrid extends AbstractList {
}


// WEBPACK FOOTER //
// ./src/framework/component/grid/AbstractGrid.js